import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { WhiteLayout, SectionHeadLayout, SwitcherSteps } from "netcompany-mdx-slide";
import oop_overall from "./assets/oop_overall.png";
import oop_class_object from "./assets/oop_class_object.png";
import oop_encap_abstraction from "./assets/oop_encap_abstraction.png";
import oop_inheritance from "./assets/oop_inheritance.png";
import oop_poly from "./assets/oop_poly.png";
import oop_overall_all from "./assets/oop_overall_all.png";
import oo_principles from "./assets/principles-of-oo.png";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SectionHeadLayout title={"OOP 101"} mdxType="SectionHeadLayout" />
    <hr></hr>
    <WhiteLayout title={"OOP 101"} mdxType="WhiteLayout">
      <div style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "5em"
      }}>
        <blockquote>
          <p parentName="blockquote">{`Object-oriented programming (OOP) is a programming paradigm based on the concept of "`}<strong parentName="p">{`objects`}</strong>{`", which can contain data and code.
The data is in the form of fields (often known as `}<strong parentName="p">{`attributes`}</strong>{` or `}<strong parentName="p">{`properties`}</strong>{`), and the code is in the form of procedures (often known as `}<strong parentName="p">{`methods`}</strong>{`).`}</p>
        </blockquote>
      </div>
    </WhiteLayout>
    <hr></hr>
    <WhiteLayout title={"OOP 101"} mdxType="WhiteLayout">
  <div style={{
        flex: "1",
        position: "relative"
      }}>
    <div style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          alignContent: "center",
          flexDirection: "column"
        }}>
      <img src={oo_principles} style={{
            maxHeight: "100%"
          }} alt="oo_principles" />
    </div>
  </div>
    </WhiteLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      